import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiGlobe } = FiIcons;

const LanguageSelector = () => {
  const { language, setLanguage, t } = useLanguage();

  return (
    <div className="relative">
      <div className="flex items-center gap-2 text-sm text-gray-600">
        <SafeIcon icon={FiGlobe} className="w-4 h-4" />
        <select
          value={language}
          onChange={(e) => setLanguage(e.target.value)}
          className="bg-transparent border-none outline-none cursor-pointer"
        >
          <option value="en">{t('english')}</option>
          <option value="zh">{t('traditionalChinese')}</option>
        </select>
      </div>
    </div>
  );
};

export default LanguageSelector;